import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactComponent } from 'src/app/share/components/contact/contact.component';
import { ImprintComponent} from 'src/app/share/components/imprint/imprint.component';
import { PrivacyComponent } from 'src/app/share/components/privacy/privacy.component';
import { SearchComponent } from '../share/components/search/search.component';
import { SelectComponent } from '../share/components/select/select.component';
import { CitizenExternComponent } from './citizen-extern.component';
import { ForgetComponent } from './forget/forget.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { EmailVerifyComponent } from './register/email-verify/email-verify.component';
import { StartExternComponent } from './start/start.component';
import { CalculatorComponent } from '../share/components/calculator/calculator.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '', component: CitizenExternComponent, children: [
      { path: '', redirectTo: 'start', pathMatch: 'full' },
      {
        path: 'start', component: StartExternComponent
      },
      {
        path: 'search', component: SearchComponent
      },
      {
        path: 'select', component: SelectComponent
      },
      {
        path: 'login', component: LoginComponent
      },
      {
        path: 'register', component: RegisterComponent
      },
      {
        path: 'emailverify', component: EmailVerifyComponent
      },
      {
        path: 'forget', component: ForgetComponent
      },
      {
        path: 'reset', component: ResetPasswordComponent
      },
      {
        path: 'contact', component: ContactComponent
      },
      {
        path: 'imprint', component: ImprintComponent
      },
      {
        path: 'privacy', component: PrivacyComponent
      },
      {
        path: 'calculator', component: CalculatorComponent
      },
      {
        path: '**', redirectTo: ''
      }
    ]
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CitizenExternRoutingModule { }

 
